<template>
	<div>
		<Modal
			:show="show"
			@close="closeModal"
			body-classes="m-0 pt-0 pb-0"
			:hideFooter="true"
			footer-classes="pt-0"
			header-classes="pb-1"
			size="lg"
		>
			<template v-slot:header>
				<h5 class="modal-title" id="modalTitle">Add New Relationship</h5>
			</template>

			<b-overlay :show="isLoading" rounded="sm">
				<div class="pt-2">
					<h5 style="flex: auto; text-align: center">
						Create a new family member profile linked to this member. This
						person will not have their own login.
					</h5>
					<h6 v-if="errorMessage" style="color: red; flex: auto; text-align: center">
						{{ errorMessage }}
					</h6>
				</div>

				<form class="pt-1 pb-1">
					<b-row>
						<b-col>
							<BaseInput
								label="First Name"
								id="relationshipFirstName"
								placeholder="First Name"
								required
								type="text"
								v-model="relationshipData.firstName"
							/>
						</b-col>
						<b-col>
							<BaseInput
								label="Last Name"
								id="relationshipLastName"
								placeholder="Last Name"
								required
								type="text"
								v-model="relationshipData.lastName"
							/>
						</b-col>
					</b-row>
					<BaseInput
						type="date"
						label="Date of Birth"
						placeholder="Enter Date Of Birth"
						id="relationshipDateOfBirth"
						required
						v-model="relationshipData.dateOfBirth"
					/>
					<BaseInput type="text" label="Gender" name="gender" required>
						<select
							class="form-control"
							id="relationshipGender"
							v-model="relationshipData.gender"
							required
						>
							<option
								v-for="options in genderOptions"
								:key="options.value"
								:value="options.value"
							>
								{{ options.name }}
							</option>
						</select>
					</BaseInput>
					<BaseInput type="text" label="Relationship" name="relationshipType" required>
						<select
							class="form-control"
							id="relationshipTypeSelect"
							v-model="relationshipData.relationshipType"
							required
						>
							<option
								v-for="options in relationshipTypeOptions"
								:key="options.value"
								:value="options.value"
							>
								{{ options.name }}
							</option>
						</select>
					</BaseInput>
					<b-row class="mr-0 mt-3 mb-3">
						<div style="flex-grow: 1"></div>
						<BaseButton
							type="primary"
							:loading="isLoading"
							:shake="shake"
							@click="submit"
							>Add Relationship</BaseButton
						>
					</b-row>
				</form>
			</b-overlay>
		</Modal>
	</div>
</template>
<script>
import { mapActions } from 'vuex';
import BaseButton from '../BaseButton.vue';
import BaseInput from '../Inputs/BaseInput.vue';
import Modal from './Modal.vue';
import AppUserManager from '../../models/AppUser/AppUserManager';

export default {
	components: { Modal, BaseInput, BaseButton },
	props: {
		show: {
			type: Boolean,
			default: false,
		},
		userData: null,
	},
	watch: {
		show: {
			handler() {
				return this.resetModal();
			},
		},
	},
	data() {
		return {
			shake: false,
			isLoading: false,
			errorMessage: null,
			relationshipData: {
				firstName: null,
				lastName: null,
				dateOfBirth: null,
				gender: null,
				relationshipType: null,
			},
			genderOptions: [
				{ name: 'Female', value: 'female' },
				{ name: 'Male', value: 'male' },
			],
			relationshipTypeOptions: [
				{ name: 'Spouse', value: 'spouse' },
				{ name: 'Child', value: 'child' },
				{ name: 'Parent', value: 'parent' },
				{ name: 'Cousin', value: 'cousin' },
				{ name: 'Nephew', value: 'nephew' },
				{ name: 'Uncle', value: 'uncle' },
				{ name: 'Niece', value: 'niece' },
				{ name: 'Aunt', value: 'aunt' },
				{ name: 'Grandparent', value: 'grandparent' },
				{ name: 'Grandchild', value: 'grandchild' },
				{ name: 'Other', value: 'other' },
			],
		};
	},
	methods: {
		...mapActions(['showNotification']),
		closeModal() {
			this.$emit('update:show', false);
			this.$emit('close');
		},
		resetModal() {
			this.errorMessage = null;
			this.relationshipData = {
				firstName: null,
				lastName: null,
				dateOfBirth: null,
				gender: null,
				relationshipType: null,
			};
		},
		submit() {
			if (
				this.$helpers.isBlank(this.relationshipData.firstName) ||
				this.$helpers.isBlank(this.relationshipData.lastName) ||
				this.$helpers.isBlank(this.relationshipData.dateOfBirth) ||
				this.$helpers.isBlank(this.relationshipData.gender) ||
				this.$helpers.isBlank(this.relationshipData.relationshipType)
			) {
				this.errorMessage = 'Please complete all the necessary fields.';
				this.shake = true;
				return;
			}
			this.isLoading = true;
			AppUserManager.addRelationship(
				this.userData.uid,
				this.relationshipData.firstName,
				this.relationshipData.lastName,
				new Date(this.relationshipData.dateOfBirth),
				this.relationshipData.gender,
				this.relationshipData.relationshipType
			)
				.then((relationshipInfo) => {
					this.isLoading = false;
					this.$emit('created', relationshipInfo);
					this.closeModal();
				})
				.catch((errorMessage) => {
					this.isLoading = false;
					this.showNotification({
						type: 'danger',
						message: errorMessage,
					});
				});
		},
	},
};
</script>
